import { ReactElement } from 'react';
import Modal from '@components/Modal';
import Buttons from '@components/Buttons';
import Spacer from '@components/Spacer';
import useNoodleApi from '@hooks/useNoodleApi';
import { useToast } from '@hooks';
import { deletePaymentMethod } from '@tsClient/paymentMethods';
import s from './PaymentMethodDeleteModal.module.scss';

type Props = {
  creatorId: string;
  paymentMethodId: string;
  onClose: () => void;
  onSubmit: () => void;
  cardLast4?: string;
  message?: string;
  isDeleteNeeded?: boolean;
};

const PaymentMethodDeleteModal = ({ creatorId, onClose, onSubmit, paymentMethodId, message, isDeleteNeeded }: Props): ReactElement => {
  const addToast = useToast();

  const {
    fetchingState: deletingPaymentMethod,
    getData: deletePaymentMethodFn,
  } = useNoodleApi(deletePaymentMethod, {
    toastOnError: true,
  });

  const handleDeletePaymentMethod = async (): Promise<void> => {
    await deletePaymentMethodFn({
      creatorId,
      paymentMethodId: paymentMethodId || '',
    });
    onSubmit();
    addToast(useToast.ToastTypeVariants.SUCCESS, 'Payment method deleted');
  };

  return (
    <Modal
      hideBottomInset
      title={'Delete payment method'}
      onClose={onClose}
    >
      <div className={s.deletePaymentMethod}>
        {message || 'You are about to delete your primary payment method. Are you sure?'}
        <Spacer size={12}/>
        {isDeleteNeeded
          ? <Buttons isSecondary onClick={handleDeletePaymentMethod} className={s.confirmButton} isFetching={deletingPaymentMethod.isFetching}>
          Confirm
          </Buttons>
          : <Buttons isSecondary onClick={onClose} className={s.confirmButton}>Confirm</Buttons>}
      </div>
    </Modal>
  );
};

export default PaymentMethodDeleteModal;
